export const ssrCodes = {
  PET_IN_CABIN: 'PETC',
};

export const ancillaryTypes = {
  ONE_PERSONAL_ITEM: 'ONE_PERSONAL_ITEM',
  TRIP_FLEX: 'TRIP_FLEX',
  PRIORITY_BOARDING: 'PRIORITY_BOARDING',

  CHECK_IN_BAG: 'CHECK_IN_BAG',
  CHECK_IN_BAG_PREDEPARTURE: 'CHECK_IN_BAG_PREDEPARTURE',
  CHECK_IN_BAG_AIRPORT: 'CHECK_IN_BAG_AIRPORT',

  CARRY_ON_BAG: 'CARRY_ON_BAG',
  CARRY_ON_BAG_PREDEPARTURE: 'CARRY_ON_BAG_PREDEPARTURE',
  CARRY_ON_BAG_AIRPORT: 'CARRY_ON_BAG_AIRPORT',
};

export const trackingAncillaryTypes = {
  TRIP_FLEX: 'TRIP_FLEX',
  PRIORITY_BOARDING: 'PRIORITY_BOARDING',
  CHECK_IN_BAG: 'CHECK_IN_BAG',
  CARRY_ON_BAG: 'CARRY_ON_BAG',
};

export const tripflexCode = {
  TRIP_FLEX: "TP",
  ENHANCED_TRIP_FLEX: "TP2",
};
